<template>
  <div class="mb-1">
    <div class="search-window">
      <el-card v-show="isSearchable" style="width: 400px">
        <el-icon
          v-if="isReplacement"
          class="mr-1 pointer search-form-icon"
          style="top: 16px"
          @click="isReplacement = false"
          ><ArrowDown
        /></el-icon>
        <el-icon v-else class="mr-1 pointer search-form-icon" @click="isReplacement = true"><ArrowRight /></el-icon>
        <span class="ml-1">
          <el-input
            id="searchInput"
            v-model="searchWord"
            style="width: 280px"
            placeholder="検索"
            @keydown.enter="onSearchInputEnter"
          />
        </span>
        <el-icon :class="arrowButtonClass()" @click="setCurrentSearchContent('up')"><Top /></el-icon>
        <el-icon :class="arrowButtonClass()" @click="setCurrentSearchContent('down')"><Bottom /></el-icon>
        <el-icon class="pointer float-end" style="color: #434e58" @click="isSearchable = false"><Close /></el-icon>
        <div v-if="isReplacement">
          <el-icon class="mr-1" style="color: transparent"><ArrowDown /></el-icon>
          <span>
            <el-input v-model="replacementWord" style="width: 280px" placeholder="置換" />
          </span>
          <el-tooltip content="置換" placement="bottom" effect="light" :show-after="2000">
            <el-icon :class="replaceButtonClass()" @click="replaceWithSearchWord()"><EditPen /></el-icon>
          </el-tooltip>
          <el-tooltip content="すべて置換" placement="bottom" effect="light" :show-after="2000">
            <el-icon :class="replaceButtonClass()" @click="replaceWithSearchWord(true)"><Refresh /></el-icon>
          </el-tooltip>
        </div>
      </el-card>
    </div>
    <el-row>
      <el-col :sm="8" :md="10" :lg="11" :xl="12">
        <div style="display: flex; align-items: center; gap: 8px">
          <span v-if="!isEditingTitle" class="pl-4" style="font-size: 1rem; font-weight: 500; color: #1f2937">{{
            title
          }}</span>
          <el-icon
            v-if="!isEditingTitle"
            class="pointer"
            style="font-size: 18px; color: #647484"
            @click="startEditTitle"
            title="タイトルを編集"
          >
            <EditPen />
          </el-icon>
          <input
            v-if="isEditingTitle"
            v-model="editTitleValue"
            ref="editTitleInput"
            class="form-control block flex-1 fs-6 border-gray-200 focus:border-gray-300 bg-slate-50 pl-4 text-gray-900 placeholder:text-gray-400 focus:ring-0 rounded-md"
            @keydown.enter="handleTitleEnter"
            @blur="handleTitleBlur"
          />
          <el-button
            v-if="isEditingTitle"
            class="title-edit-actions"
            size="default"
            color="#91cdbe"
            type="primary"
            style="
              --el-button-text-color: #647484;
              --el-button-hover-text-color: #647484;
              --el-button-active-text-color: #647484;
            "
            @click="saveTitle"
            >保存</el-button
          >
          <el-button
            v-if="isEditingTitle"
            class="title-edit-actions btn-outline-primary"
            size="default"
            @click="cancelEditTitle"
            >キャンセル</el-button
          >
        </div>
      </el-col>
      <el-col :sm="2" :md="2" :lg="2" :xl="2" class="text-stylebar">
        <span class="pointer img-hover ml-3" @click="applyStyle('torikeshi_line')">
          <img :src="'/取り消し線.png'" style="width: 32px" />
        </span>
        <!-- <span class="pointer img-hover ml-2" @click="tatechuyokoFunction()">
          <img src="/縦中横.png" style="width: 32px" />
        </span> -->
        <span class="pointer img-hover ml-3" @click="applyStyle('text_color')">
          <img :src="'/文字色.png'" style="width: 32px" />
        </span>
      </el-col>
      <el-col
        :sm="13"
        :md="11"
        :lg="9"
        :xl="8"
        class="text-end"
        style="display: flex; align-items: center; justify-content: flex-end; gap: 16px"
      >
        <el-popover placement="bottom" :width="500" trigger="click" :show-arrow="true">
          <template #reference>
            <el-icon class="pointer" style="font-size: 24px; color: #647484" title="ショートカット・使い方">
              <QuestionFilled />
            </el-icon>
          </template>
          <div class="help-popover-content">
            <div class="help-section-heading">
              <svg
                class="help-section-icon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
                focusable="false"
              >
                <rect x="2" y="6" width="20" height="12" rx="2" />
                <path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M8 14h8" />
              </svg>
              <h3 class="help-section-title">ショートカットキー・機能</h3>
            </div>
            <table style="width: 100%; font-size: 14px; border-collapse: collapse">
              <thead>
                <tr style="border-bottom: 2px solid #ebe8e6">
                  <th style="text-align: left; padding: 8px; color: #647484">操作</th>
                  <th style="text-align: left; padding: 8px; color: #647484">キー / 操作方法</th>
                </tr>
              </thead>
              <tbody>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px; font-weight: bold">柱作成</td>
                  <td style="padding: 8px"><kbd>Tab</kbd></td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px; font-weight: bold">台詞作成</td>
                  <td style="padding: 8px"><kbd>「</kbd> を入力</td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">上書き保存</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + S</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">検索</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + F</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">全選択</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + A</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">元に戻す（Undo）</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + Z</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">やり直す（Redo）</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd + Shift + Z' : 'Ctrl + Y' }}</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">コピー</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + C</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">切り取り</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + X</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">貼り付け</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + V</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">柱間ジャンプ</td>
                  <td style="padding: 8px">
                    <kbd>{{ isMac ? 'Cmd' : 'Ctrl' }} + ↑↓←→</kbd>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">範囲選択</td>
                  <td style="padding: 8px"><kbd>Shift + ↑↓←→</kbd></td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">取り消し線</td>
                  <td style="padding: 8px">
                    <img :src="'/取り消し線.png'" style="width: 20px; vertical-align: middle" />
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">文字色</td>
                  <td style="padding: 8px"><img :src="'/文字色.png'" style="width: 20px; vertical-align: middle" /></td>
                </tr>
                <tr style="border-bottom: 1px solid #f0f0f0">
                  <td style="padding: 8px">柱一覧</td>
                  <td style="padding: 8px">
                    <el-icon style="vertical-align: middle; font-size: 16px"><List /></el-icon>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="tips-section">
              <div class="help-section-heading">
                <svg
                  class="help-section-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M9 18h6" />
                  <path d="M10 22h4" />
                  <path d="M12 2a7 7 0 0 0-4 12.7c.6.5 1 1.3 1 2.1v.2h6v-.2c0-.8.4-1.6 1-2.1A7 7 0 0 0 12 2z" />
                </svg>
                <h3 class="help-section-title">Tips</h3>
              </div>
              <ul class="tips-list">
                <li class="tips-item">
                  <span class="tips-bullet">・</span>
                  <span>紙に印刷する際はPDF保存後にA4横でプリントアウトして下さい。</span>
                </li>
                <li class="tips-item">
                  <span class="tips-bullet">・</span>
                  <span>ト書きで文字を強調したい場合は『』などで代用して下さい。</span>
                </li>
                <li class="tips-item">
                  <span class="tips-bullet">・</span>
                  <span
                    >別エディタから原稿を移動してくる場合はテキスト全体をコピー＆ペースト後に手動で整形して下さい。</span
                  >
                </li>
              </ul>
            </div>
          </div>
        </el-popover>
        <el-switch
          v-model="isAutoSave"
          inline-prompt
          style="--el-switch-on-color: #91cdbe; --el-switch-off-color: #bbbdbf"
          active-text="自動保存ON"
          inactive-text="自動保存OFF"
        />
        <el-dropdown trigger="hover" placement="bottom">
          <el-button size="large" circle>
            <el-icon class="pointer"><Document /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="outputStryFile">STRYファイル出力</el-dropdown-item>
              <el-dropdown-item @click="savePdf" :loading="pdfLoading">PDF保存</el-dropdown-item>
              <el-dropdown-item @click="dialogFormVisible = true">名前をつけて保存</el-dropdown-item>
              <el-dropdown-item @click="save">上書き保存</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </el-col>

      <el-dialog
        v-model="dialogFormVisible"
        title="名前をつけて保存"
        @opened="$nextTick(() => $refs.copyDocumentSaveButton?.$el?.focus())"
      >
        <el-form @submit.prevent="copyDocumentSave">
          <el-form-item label="名前" :label-width="50">
            <input
              v-model="copyDocumentTitle"
              autocomplete="off"
              class="form-control block flex-1 fs-6 border-gray-200 focus:border-gray-300 bg-slate-50 text-gray-900 placeholder:text-gray-400 focus:ring-0 rounded-md"
            />
          </el-form-item>
        </el-form>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false" class="btn-outline-primary">閉じる</el-button>
          <el-button
            ref="copyDocumentSaveButton"
            color="#91cdbe"
            type="primary"
            style="
              --el-button-text-color: #647484;
              --el-button-hover-text-color: #647484;
              --el-button-active-text-color: #647484;
            "
            @click="copyDocumentSave()"
            >保存する</el-button
          >
        </span>
      </el-dialog>

      <el-dialog
        v-model="pdfUnsupportedGlyphDialogVisible"
        title="PDF保存の確認"
        width="640"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @closed="closePdfUnsupportedGlyphDialog(false)"
      >
        <div class="pdf-warning-body">
          <p class="pdf-warning-title">以下の文字はPDFで四角（□）に置き換わる可能性があります。保存を続行しますか？</p>
          <el-scrollbar max-height="280px">
            <table class="pdf-warning-table">
              <thead>
                <tr>
                  <th>文字</th>
                  <th>Unicode番号（U+）</th>
                  <th>ページ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in pdfUnsupportedGlyphs" :key="item.character">
                  <td>
                    <span class="pdf-warning-char">{{ formatPdfGlyphChar(item.character) }}</span>
                  </td>
                  <td class="pdf-warning-code">{{ formatPdfGlyphCodePoint(item.character) }}</td>
                  <td>{{ formatPdfGlyphPages(item.pages) }}</td>
                </tr>
              </tbody>
            </table>
          </el-scrollbar>
        </div>
        <span class="dialog-footer pdf-warning-dialog-footer">
          <el-button class="btn-outline-primary" @click="closePdfUnsupportedGlyphDialog(false)">閉じる</el-button>
          <el-button
            color="#91cdbe"
            type="primary"
            style="
              --el-button-text-color: #647484;
              --el-button-hover-text-color: #647484;
              --el-button-active-text-color: #647484;
            "
            @click="closePdfUnsupportedGlyphDialog(true)"
            >このまま保存する</el-button
          >
        </span>
      </el-dialog>
    </el-row>
  </div>
  <div class="flex gap-4">
    <div v-show="!isHashiraListVisible" class="mt-4" style="width: 30px">
      <el-tooltip content="柱一覧" placement="right" effect="light" :show-after="500">
        <el-button size="large" circle @click="isHashiraListVisible = true">
          <el-icon class="pointer"><List /></el-icon>
        </el-button>
      </el-tooltip>
    </div>
    <div
      v-show="isHashiraListVisible"
      class="flex-shrink-0"
      :style="{ width: hashiraListWidth + 'px', position: 'relative' }"
    >
      <div
        class="mb-1"
        style="
          font-size: 20px;
          color: #647484;
          margin-top: 1em;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <span>柱一覧</span>
        <el-icon class="pointer mx-2" style="color: #909399; font-size: 16px" @click="isHashiraListVisible = false"
          ><Close
        /></el-icon>
      </div>
      <el-scrollbar style="height: 44em">
        <el-menu v-model:default-active="activeIndex" style="overflow-x: hidden">
          <el-menu-item
            v-for="content in contents
              .filter((content) => content.tag_type === 'hashira')
              .sort((a, b) => a.hashira_index - b.hashira_index)"
            :key="content.uuid"
            :index="content.uuid"
            style="background-color: #ebe8e6; color: #647484"
            @click="scrollToContent(content.uuid)"
          >
            {{ content.hashira_index }}. {{ truncate(content.body, 20) }}
          </el-menu-item>
        </el-menu>
      </el-scrollbar>
      <div
        @mousedown="startResize"
        class="hashira-resize-handle"
        :style="{ backgroundColor: isDragging ? '#91cdbe' : '#c8d3d3' }"
      ></div>
    </div>
    <div id="papers" class="papers flex-1" v-loading="isGettingSentences" element-loading-text="読み込み中...">
      <div id="paper-container" class="paper-container">
        <div
          v-for="(page, pageIndex) in pageSeparateArray"
          :key="pageIndex"
          class="paper"
          :style="{ right: pageIndex * 67 + 'em' }"
        >
          <div class="line"></div>
          <div class="sentence-board">
            <template v-for="content in page" :key="content.content.uuid + '-' + content.lineFrom">
              <BasicSentence
                v-if="content.content.tag_type == 'togaki' || content.content.tag_type == 'serifu'"
                :content-prop="content.content"
                :content-body="content.content?.updatingbody"
                :line-from="content.lineFrom"
                :line-to="content.lineTo"
                :search-word="searchWord"
                :current-search="currentSearch"
                :select-from="selectFrom"
                :select-to="selectTo"
                :text-color="textColor"
                :is-composing="isComposing"
                :enter-key-pressed="enterKeyPressed"
                :is-mouse-down="isMouseDown"
                @change="addConfirmEvent"
                @composing-start="composingStartHandler"
                @search-refresh="reSearchEditedContent"
              ></BasicSentence>
              <hashira
                v-if="content.content.tag_type == 'hashira'"
                :content-prop="content.content"
                :content-body="content.content?.updatingbody"
                :line-from="content.lineFrom"
                :line-to="content.lineTo"
                :hashira-index="content.hashiraIndex"
                :search-word="searchWord"
                :current-search="currentSearch"
                :select-from="selectFrom"
                :select-to="selectTo"
                :text-color="textColor"
                :is-composing="isComposing"
                :enter-key-pressed="enterKeyPressed"
                :is-mouse-down="isMouseDown"
                @change="addConfirmEvent"
                @composing-start="composingStartHandler"
                @search-refresh="reSearchEditedContent"
              ></hashira>
            </template>
          </div>
          <p class="page-number">-{{ pageIndex + 1 }}-</p>
        </div>
      </div>
    </div>
  </div>
  <EditorContextMenu
    :visible="contextMenu.visible"
    :position="contextMenu.position"
    :can-cut-or-copy="Boolean(selectTo.contentID)"
    theme="light"
    @select="handleContextMenuAction"
    @close="closeContextMenu"
  />
</template>

<script>
import axios from 'axios';
import http_method from '../mixins/http_method';
import redo_undo_method from '../mixins/redo_undo_method';
import content_method from '../mixins/content_method';
import caret_method from '../mixins/caret_method';
import hardware_action_method from '../mixins/hardware_action_method';
import set_range_method from '../mixins/set_range_method';
import pdf_method from '../mixins/pdf_method';
import { useCaretStore } from '../stores/caret_store.js';
import Hashira from './Hashira.vue';
import BasicSentence from './BasicSentence.vue';
import EditorContextMenu from './EditorContextMenu.vue';
import 'element-plus';
import { nextTick } from 'vue';
import * as CONSTS from '../constants.js';
import Content from './../classes/content.js';
import { ref } from 'vue';
import { graphemeCount, sliceGraphemes, codeUnitToGrapheme } from '../text_segment.js';
export default {
  components: { Hashira, BasicSentence, EditorContextMenu },
  data() {
    return {
      title: '',
      saving: false,
      loading: false,
      pdfLoading: false,
      separateIndex: 0, // 改ページ部分のcaret位置の要素番号
      isLineHeadAtLeftPageSeparate: false, // page-separateの左側の行頭にcaretがあるかどうか
      togakiMaxCount: CONSTS.TOGAKI_MAX_COUNT,
      firstSerifuMaxCount: CONSTS.FIRST_SERIFU_MAX_COUNT,
      serifuMaxCount: CONSTS.SERIFU_MAX_COUNT,
      hashiraMaxCount: CONSTS.HASHIRA_MAX_COUNT,
      maxLinesPerPage: CONSTS.MAX_LINES_PER_PAGE,
      dialogFormVisible: false,
      copyDocumentTitle: '',
      selectedTexts: [],
      isChanged: false, // contentに変更があったかどうかを判断するフラグ
      isComposing: false,
      isAtSentenceBoard: false,
      isGettingSentences: true,
      textColor: 'red',
      isSearchable: false,
      searchWord: '',
      isReplacement: false,
      replacementWord: '',
      currentSearch: {
        content: null,
        index: null,
      },
      isMouseDown: false,
      didPointerMoveWhileMouseDown: false,
      selectFrom: {
        contentID: '',
        wordIndex: 0,
      },
      selectTo: {
        contentID: '',
        wordIndex: 0,
      },
      undoRecord: [],
      redoRecord: [],
      countId: null, // 自動保存の秒数カウントに使用するsetTimeoutのid
      isAutoSave: false,
      enterKeyPressed: false,
      activeIndex: '', // 柱一覧で選択中のメニュー項目
      hashiraListWidth: 200, // 柱一覧カードの幅
      isHashiraListVisible: false, // 柱一覧パネルの表示状態
      isDragging: false, // リサイズハンドルをドラッグ中かどうか
      dragStartX: 0, // ドラッグ開始時のX座標
      dragStartWidth: 0, // ドラッグ開始時の幅
      resizeObserver: null, // 柱一覧カードのリサイズ監視用
      // タイトル編集用
      isEditingTitle: false,
      editTitleValue: '',
      pdfUnsupportedGlyphDialogVisible: false,
      pdfUnsupportedGlyphs: [],
      pdfUnsupportedGlyphDialogResolver: null,
      contextMenu: {
        visible: false,
        position: { x: 0, y: 0 },
      },
    };
  },
  mixins: [
    http_method,
    redo_undo_method,
    content_method,
    caret_method,
    hardware_action_method,
    set_range_method,
    pdf_method,
  ],
  async created() {
    this.title = this.documentTitle;
    this.copyDocumentTitle = this.documentTitle;
    await this.getSentences();
    this.setStatusSaved(true);
    if (this.isNewDocument) this.announceMessage('success', '脚本が新規作成されました');
  },
  mounted() {
    // sentence-board内のonkeydownイベントの登録
    document.getElementById('paper-container').onkeydown = this.keyDownActionAtPaper;
    // document.getElementById('sentence-board').onkeyup = this.keyUpActionAtPaper;
    // document.getElementById('sentence-board').onmouseup = this.mouseDownActionAtSentenceBoard;
    // document.getElementById('paper-container').onmouseup = this.mouseDownActionAtPaper;

    // onkeydownイベントの登録
    document.onkeydown = this.keyDownAction;

    // リサイズ用のイベントリスナーを追加
    document.addEventListener('mousemove', this.doResize);
    document.addEventListener('mouseup', this.stopResize);

    // 柱一覧カードの幅変更を監視
    this.$nextTick(() => {
      const cardEl = this.$refs.hashiraListCard?.$el;
      if (cardEl) {
        let initialWidth = cardEl.offsetWidth;
        this.resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const newWidth = entry.target.offsetWidth;
            // 初期値と異なる場合のみ更新（ユーザーの手動リサイズ時）
            if (Math.abs(newWidth - initialWidth) > 5) {
              this.hashiraListWidth = newWidth;
              initialWidth = newWidth;
            }
          }
        });
        this.resizeObserver.observe(cardEl);
      }
    });

    document.addEventListener('selectionchange', (event) => {
      if (!window.getSelection().isCollapsed && !this.isComposing) {
        // テキスト選択状態をはずす
        window.getSelection().removeAllRanges();
      }
    });
    document.getElementById('paper-container').addEventListener('mousedown', (event) => {
      if (event.button !== 0) return;
      this.contents.forEach((content) => {
        if (content.selectFrom != -1) {
          content.selectFrom = -1;
        }
        if (content.selectTo != -1) {
          content.selectTo = -1;
        }
      });
      this.isMouseDown = true;
      this.didPointerMoveWhileMouseDown = false;
      // event.targetはTextノードの場合があるためparentElement経由でElementを取得する
      const targetElement = event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;
      const clickedWordElement = targetElement?.closest('[data-index]');
      if (clickedWordElement?.parentElement?.dataset?.contentid) {
        this.selectFrom.contentID = clickedWordElement.parentElement.dataset.contentid;
        this.selectFrom.wordIndex = Number(clickedWordElement.dataset.index);
      } else {
        // data-indexを直接クリックしていない場合も、最寄りの単語を基準にselectFromを設定する
        const nearestWordElement = this.findNearestWordElement(event.clientX, event.clientY);
        if (nearestWordElement?.parentElement?.dataset?.contentid) {
          this.selectFrom.contentID = nearestWordElement.parentElement.dataset.contentid;
          this.selectFrom.wordIndex = Number(nearestWordElement.dataset.index);
        } else {
          this.selectFrom.contentID = '';
          this.selectFrom.wordIndex = 0;
        }
        // mousedown時点でブラウザ標準のキャレット配置（誤った行への配置）が起きる前に、
        // こちらで求めた位置へ即座にキャレットを移動させる（selectFromはドラッグ選択のため保持する）
        if (targetElement?.closest('.paper')) {
          event.preventDefault();
          this.placeCaretAtNearestWord(event);
        }
      }
      this.selectTo.contentID = '';
      this.selectTo.wordIndex = 0;
    });
    document.getElementById('paper-container').addEventListener('mouseup', (event) => {
      if (event.button !== 0) return;
      this.isMouseDown = false;
      this.setCaretSelectionFirst();
      const targetElement = event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;
      if (targetElement?.closest('.paper') && !this.didPointerMoveWhileMouseDown && !this.selectTo.contentID) {
        this.trySetCaretNearPoint(event);
      }
    });
    document.getElementById('paper-container').addEventListener('pointermove', (event) => {
      if (this.isMouseDown) {
        this.didPointerMoveWhileMouseDown = true;
        const targetElement = event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;
        const pointedWordElement = targetElement?.closest('[data-index]');
        if (pointedWordElement?.parentElement?.dataset?.contentid) {
          this.selectTo.contentID = pointedWordElement.parentElement.dataset.contentid;
          this.selectTo.wordIndex = Number(pointedWordElement.dataset.index);
        }
        this.updateSelectRange();
      }
    });
    document.getElementById('paper-container').addEventListener('mousedown', this.preventCaretMoveOnContextMenu, true);
    document.getElementById('paper-container').addEventListener('contextmenu', this.openContextMenu);
  },
  beforeUnmount() {
    // ResizeObserverのクリーンアップ
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    // リサイズイベントリスナーのクリーンアップ
    document.removeEventListener('mousemove', this.doResize);
    document.removeEventListener('mouseup', this.stopResize);
    document
      .getElementById('paper-container')
      ?.removeEventListener('mousedown', this.preventCaretMoveOnContextMenu, true);
    document.getElementById('paper-container')?.removeEventListener('contextmenu', this.openContextMenu);
  },
  computed: {
    // Mac環境かどうかを判定
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },
    /**
     * ページの境目があるcontentのsort_keyの配列を作成する
     * @returns {Array} ページの境目があるcontentのsort_keyの配列
     */
    pageSeparateArray() {
      const result = [];
      let lineCount = 0; // ページ毎の行数をカウントする
      let page = [];
      let targetContent = this.contents[0];
      let hashiraCount = 0;
      while (targetContent) {
        let totalLineNum = targetContent.lineNum;
        let lineNum = 0; // 処理が終わっていない行数を記録しておく
        let pageCount = 1;
        if (targetContent.tag_type == 'hashira') {
          hashiraCount++;
          targetContent.hashira_index = hashiraCount;
          lineCount = lineCount + 1;
          if (lineCount == CONSTS.MAX_LINES_PER_PAGE) {
            result.push(page);
            page = [];
            lineCount = 1;
          }
        }
        while (lineCount + (totalLineNum - lineNum) > CONSTS.MAX_LINES_PER_PAGE) {
          page.push({
            content: targetContent,
            lineFrom: lineNum,
            lineTo:
              lineNum == 0
                ? CONSTS.MAX_LINES_PER_PAGE - lineCount
                : CONSTS.MAX_LINES_PER_PAGE * (pageCount - 1) + lineNum,
            hashiraIndex: hashiraCount,
          });
          lineNum = lineNum + (CONSTS.MAX_LINES_PER_PAGE - lineCount);
          result.push(page);
          page = [];
          lineCount = 0;
          pageCount++;
        }
        page.push({
          content: targetContent,
          lineFrom: lineNum,
          lineTo: totalLineNum,
          hashiraIndex: hashiraCount,
        });
        if (targetContent.tag_type == 'hashira') {
          lineCount = lineCount + 1;
        }
        lineCount = (lineCount + (totalLineNum - lineNum)) % CONSTS.MAX_LINES_PER_PAGE;
        if (lineCount == 0) {
          result.push(page);
          page = [];
        } else if (targetContent.tag_type == 'hashira' && lineCount == 1) {
          result.push(page);
          page = [];
          lineCount = 0;
        }
        targetContent = targetContent.next;
      }
      result.push(page);
      return result;
    },
    // 検索結果を返す
    searchResults() {
      // 検索が無効な場合はthis.contentsに触れずに早期リターン
      // （this.contentsに依存しないので、Enter等でcontentsが変わっても再評価されない）
      if (this.searchWord == '' || !this.isSearchable) return [];
      let results = [];
      // リセット処理
      this.contents.forEach((content) => {
        content.searchWordStartIndex = null;
        content.itemsCount = null;
      });
      results = this.contents.filter((content) => content.body.includes(this.searchWord));
      if (results.length != 0) {
        results.forEach((content) => {
          content.searchWordStartIndex = codeUnitToGrapheme(content.body, content.body.indexOf(this.searchWord));
          // 1行の中で検索文字列がヒットする数
          content.itemsCount = content.body.split(this.searchWord).length - 1;
        });
      }
      return results;
    },
  },
  props: {
    documentId: {
      type: Number,
      default: null,
    },
    documentTitle: {
      type: String,
      default: '',
    },
    currentUserId: {
      type: Number,
      default: null,
    },
    isNewDocument: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    preventCaretMoveOnContextMenu(event) {
      if (event.button === 2 || (this.isMac && event.button === 0 && event.ctrlKey)) {
        event.preventDefault();
      }
    },
    openContextMenu(event) {
      event.preventDefault();
      const menuWidth = 152;
      const menuHeight = 116;
      this.contextMenu.position = {
        x: Math.max(Math.min(event.clientX, window.innerWidth - menuWidth), 0),
        y: Math.max(Math.min(event.clientY, window.innerHeight - menuHeight), 0),
      };
      this.contextMenu.visible = true;
    },
    closeContextMenu() {
      this.contextMenu.visible = false;
    },
    handleContextMenuAction(action) {
      this.closeContextMenu();
      const shortcutEvent = new KeyboardEvent('keydown', {
        key: action === 'paste' ? 'v' : action === 'cut' ? 'x' : 'c',
        metaKey: this.isMac,
        ctrlKey: !this.isMac,
      });

      if (action === 'paste') {
        this.vKeyAction(shortcutEvent);
      } else {
        this.cxKeyAction(shortcutEvent);
      }
    },
    /**
     * 指定座標に最も近いcontenteditable内の[data-index]要素を返す
     * @returns {Element|null}
     */
    findNearestWordElement(clientX, clientY) {
      const paperContainer = document.getElementById('paper-container');
      if (!paperContainer) return null;

      const focusableContents = Array.from(paperContainer.querySelectorAll('[data-contentid][contenteditable="true"]'));
      if (focusableContents.length === 0) return null;

      const nearestContent = focusableContents.reduce((nearest, contentElement) => {
        const rect = contentElement.getBoundingClientRect();
        const dx = Math.max(rect.left - clientX, 0, clientX - rect.right);
        const dy = Math.max(rect.top - clientY, 0, clientY - rect.bottom);
        const distanceSquared = dx * dx + dy * dy;

        if (!nearest || distanceSquared < nearest.distanceSquared) {
          return { element: contentElement, distanceSquared };
        }
        return nearest;
      }, null);

      if (!nearestContent?.element) return null;

      const words = Array.from(nearestContent.element.querySelectorAll('[data-index]'));
      if (words.length === 0) return null;

      // 縦書きのため、まず横方向(行)で最も近い行を求め、その行内で縦方向の距離のみで最も近い文字を選ぶ
      // （そうしないと、1行が複数行に折り返された際に空白部分のクリックが隣の行に吸われてしまう）
      const nearestColumnDistance = words.reduce((nearest, wordElement) => {
        const rect = wordElement.getBoundingClientRect();
        const dx = Math.max(rect.left - clientX, 0, clientX - rect.right);
        return nearest === null || dx < nearest ? dx : nearest;
      }, null);

      const columnWords = words.filter((wordElement) => {
        const rect = wordElement.getBoundingClientRect();
        const dx = Math.max(rect.left - clientX, 0, clientX - rect.right);
        return dx === nearestColumnDistance;
      });

      const nearestWord = columnWords.reduce((nearest, wordElement) => {
        const rect = wordElement.getBoundingClientRect();
        const dy = Math.max(rect.top - clientY, 0, clientY - rect.bottom);

        if (!nearest || dy < nearest.dy) {
          return { element: wordElement, dy };
        }
        return nearest;
      }, null);

      return nearestWord?.element ?? null;
    },
    /**
     * イベント座標に最も近い単語へネイティブキャレットを移動する（selectFrom/selectToには触れない）
     * @returns {boolean} キャレットを移動できたかどうか
     */
    placeCaretAtNearestWord(event) {
      const targetElement = event.target.nodeType === Node.TEXT_NODE ? event.target.parentElement : event.target;
      if (!targetElement?.closest('.paper') || targetElement?.closest('[data-index]')) return false;

      const nearestWordElement = this.findNearestWordElement(event.clientX, event.clientY);
      if (!nearestWordElement) return false;

      const wordRect = nearestWordElement.getBoundingClientRect();
      const offset =
        nearestWordElement.childNodes.length > 0 && event.clientY > wordRect.top + wordRect.height / 2 ? 1 : 0;
      const selection = window.getSelection();
      if (!selection) return false;

      const range = document.createRange();
      range.setStart(nearestWordElement, offset);
      range.setEnd(nearestWordElement, offset);
      selection.removeAllRanges();
      selection.addRange(range);
      nearestWordElement.closest('[data-contentid][contenteditable="true"]')?.focus();

      return true;
    },
    trySetCaretNearPoint(event) {
      if (!this.placeCaretAtNearestWord(event)) return;

      this.selectFrom.contentID = '';
      this.selectFrom.wordIndex = 0;
      this.selectTo.contentID = '';
      this.selectTo.wordIndex = 0;
    },
    /**
     * ページ遷移前にアラートを出す
     * @return {string}
     */
    unloaded(e) {
      var confirmMessage = '内容が保存されない可能性がありますがよろしいですか？';
      e.returnValue = confirmMessage;
      return confirmMessage;
    },
    /**
     * ページ遷移前にアラートを出すイベントを追加する（既に追加されていたら追加しない）
     */
    addConfirmEvent() {
      if (!this.isChanged) {
        window.addEventListener('beforeunload', this.unloaded, false);
        this.isChanged = true;
      }
      if (this.countId) this.countStop();
      // 自動保存機能ががONの場合のみ
      if (this.isAutoSave) {
        this.countId = setTimeout(this.save, 15000);
      }
      this.isComposing = false;
    },
    /**
     * ページ遷移前にアラートを出すイベントを削除する
     */
    removeConfirmEvent() {
      window.removeEventListener('beforeunload', this.unloaded, false);
      this.isChanged = false;
      this.countStop();
    },
    /**
     * 保存された場合に自動保存用秒数カウントを停止する関数
     */
    countStop() {
      clearTimeout(this.countId);
      this.countId = null;
    },
    // 柱採番
    setHashiraIndex() {
      this.contents
        .filter((content) => content.tag_type == 'hashira')
        .sort((a, b) => (a.sort_key > b.sort_key ? 1 : -1))
        .forEach((content, index) => (content['hashira_index'] = index + 1));
    },
    // タイトル編集開始
    startEditTitle() {
      this.isEditingTitle = true;
      this.editTitleValue = this.title;
      this.$nextTick(() => {
        if (this.$refs.editTitleInput) {
          this.$refs.editTitleInput.focus();
        }
      });
    },
    // タイトル入力欄でEnterキーが押された時（IME変換中は無視）
    handleTitleEnter(event) {
      if (event.isComposing) return;
      this.saveTitle();
    },
    // タイトル入力欄からフォーカスが外れた時（保存/キャンセルボタンへの移動時は除く）
    handleTitleBlur(event) {
      const relatedTarget = event.relatedTarget;
      if (relatedTarget && relatedTarget.closest && relatedTarget.closest('.title-edit-actions')) return;
      this.cancelEditTitle();
    },
    // タイトル保存
    async saveTitle() {
      if (this.editTitleValue.trim() === '' || this.editTitleValue === this.title) {
        this.isEditingTitle = false;
        return;
      }
      const newTitle = this.editTitleValue;
      this.announceMessage('info', 'タイトルを保存しています...', { closeable: false });
      const response = await this.patchMethod(
        { title: newTitle },
        `/documents/${this.documentId}/update_title.json`,
        'タイトルの保存に失敗しました。',
      );
      this.closeMessages();
      if (response && response.status === 200) {
        this.isEditingTitle = false;
        this.title = newTitle;
        this.copyDocumentTitle = newTitle;
        this.announceMessage('success', 'タイトルを保存しました');
      } else {
        this.announceMessage('error', 'タイトルの保存に失敗しました。');
      }
    },
    // タイトル編集キャンセル
    cancelEditTitle() {
      this.isEditingTitle = false;
      this.editTitleValue = this.title;
    },
    // タイトルと本文の保存
    async save() {
      if (this.saving) {
        this.announceMessage('warning', '保存中に再度保存することはできません', { closeable: false });
        return;
      }
      this.announceMessage('info', '保存しています...', { closeable: false });
      let response = await this.updateDocument();
      // 保存に成功した場合
      if (response) {
        this.announceMessage('success', '保存しました');
        this.copyDocumentTitle = this.title;
        this.removeConfirmEvent();
      }
    },
    // 名前をつけて保存
    async copyDocumentSave() {
      if (this.saving) return;
      this.saving = true;
      let sortKeyCount = 0;
      let formData = new FormData();
      formData.append(`document[title]`, this.copyDocumentTitle);
      let currentContent = this.contents[0];
      while (currentContent) {
        formData.append(`document[sentences_attributes][][body]`, currentContent.body);
        formData.append(`document[sentences_attributes][][tag_type]`, currentContent.tag_type);
        formData.append(`document[sentences_attributes][][sort_key]`, sortKeyCount);
        sortKeyCount++;
        // in-memory の style は書記素基準。DB へはコードユニット基準に変換して保存する。
        currentContent.styleAsCodeUnit().forEach((style) => {
          formData.append(`document[sentences_attributes][][styles_attributes][][style_type]`, style.style_type);
          formData.append(`document[sentences_attributes][][styles_attributes][][color]`, style.color);
          formData.append(`document[sentences_attributes][][styles_attributes][][start_index]`, style.start_index);
          formData.append(`document[sentences_attributes][][styles_attributes][][end_index]`, style.end_index);
        });
        currentContent = currentContent.next;
      }
      const response = await this.postMethod(
        formData,
        `/documents/${this.documentId}/copy_document.json`,
        '保存に失敗しました。',
      );
      this.closeMessages();
      this.saving = false;
      if (response && response.status == 201) {
        this.removeConfirmEvent();
        location.href = response.data.url;
      } else {
        this.announceMessage('error', '保存に失敗しました。');
      }
    },
    // pdfをダウンロード
    async savePdf() {
      this.pdfLoading = true;
      const fontPath = '/fonts/NotoSerifJP-Light.ttf';
      const unsupportedGlyphs = await this.detectUnsupportedGlyphsForTextPdf(this.contents[0], fontPath);
      if (unsupportedGlyphs.length > 0) {
        const shouldContinue = await this.confirmPdfUnsupportedGlyphs(unsupportedGlyphs);
        if (!shouldContinue) {
          this.pdfLoading = false;
          return;
        }
      }

      this.announceMessage('info', 'PDFをダウンロードしています...', { closeable: false });
      // フォント/ロゴがキャッシュ済みだと描画前にPDF生成の同期処理でメインスレッドが
      // ブロックされメッセージが表示されないため、フェードイン完了を待ってから重い処理を開始する
      await new Promise((resolve) => setTimeout(resolve, 350));
      let saveSuccess = await this.saveContentAsTextPdf(this.contents[0], { skipUnsupportedGlyphCheck: true });
      this.closeMessages();
      this.pdfLoading = false;
      if (!saveSuccess) return;
    },
    confirmPdfUnsupportedGlyphs(unsupportedGlyphs) {
      this.pdfUnsupportedGlyphs = unsupportedGlyphs;
      this.pdfUnsupportedGlyphDialogVisible = true;

      return new Promise((resolve) => {
        this.pdfUnsupportedGlyphDialogResolver = resolve;
      });
    },
    closePdfUnsupportedGlyphDialog(shouldContinue) {
      const resolver = this.pdfUnsupportedGlyphDialogResolver;
      this.pdfUnsupportedGlyphDialogResolver = null;
      this.pdfUnsupportedGlyphDialogVisible = false;

      if (resolver) {
        resolver(shouldContinue);
      }
    },
    formatPdfGlyphPages(pages) {
      return pages.map((page) => `${page}ページ`).join(' / ');
    },
    formatPdfGlyphCodePoint(char) {
      if (!char) return '-';
      const codePoints = Array.from(char, (singleChar) => singleChar.codePointAt(0)).filter(
        (codePoint) => codePoint !== undefined,
      );
      if (codePoints.length === 0) return '-';
      return codePoints.map((codePoint) => `U+${codePoint.toString(16).toUpperCase().padStart(4, '0')}`).join(' ');
    },
    formatPdfGlyphChar(char) {
      if (char === ' ') return '[space]';
      if (char === '\t') return '[tab]';
      if (char === '\n') return '[newline]';
      if (!char) return '[unknown]';

      const chars = Array.from(char);
      if (chars.length === 0) return '[unknown]';

      const isInvisibleCodePoint = (codePoint, singleChar) => {
        const isVariationSelector =
          (codePoint >= 0xfe00 && codePoint <= 0xfe0f) || (codePoint >= 0xe0100 && codePoint <= 0xe01ef);
        const isZeroWidth =
          codePoint === 0x200b || codePoint === 0x200c || codePoint === 0x200d || codePoint === 0x2060;
        const isCombiningMark = /\p{M}/u.test(singleChar);
        const isControl = codePoint <= 0x1f || (codePoint >= 0x7f && codePoint <= 0x9f);
        return isVariationSelector || isZeroWidth || isCombiningMark || isControl;
      };

      const hasVisibleBase = chars.some((singleChar) => {
        const codePoint = singleChar.codePointAt(0);
        if (codePoint === undefined) return false;
        return !isInvisibleCodePoint(codePoint, singleChar);
      });

      if (hasVisibleBase) return char;

      const firstCodePoint = chars[0].codePointAt(0);
      if (firstCodePoint === undefined) return '[unknown]';
      return `[U+${firstCodePoint.toString(16).toUpperCase().padStart(4, '0')}]`;
    },
    tatechuyokoFunction() {
      console.log('縦中横');
    },
    replaceButtonClass() {
      if (this.searchWord == '') return 'ml-4 search-form-icon-no-active';
      return 'ml-4 pointer search-form-icon';
    },
    arrowButtonClass() {
      if (this.searchResults.length > 1 || this.searchResults[0]?.itemsCount > 1) {
        return 'ml-4 pointer search-form-icon';
      } else {
        return 'ml-4 search-form-icon-no-active';
      }
    },
    /**
     * 検索ワード入力欄でEnterキーが押されたとき、次の検索ヒットへ移動する（矢印下ボタンと同じ挙動）
     * IME変換確定のEnterは無視する。
     * @param {KeyboardEvent} event
     */
    onSearchInputEnter(event) {
      // IME変換確定のEnterは無視
      if (event.isComposing) return;
      // 検索が無効／検索ワードが空／ヒットが無い場合は何もしない
      if (!this.isSearchable || this.searchWord === '' || !this.currentSearch.content) return;
      this.setCurrentSearchContent('down');
    },
    // テラストリーファイルを出力
    outputStryFile() {
      // 連結リスト（next）を辿って正しい表示順で出力する。
      // 編集後は各contentのsort_keyが最新の並び順を反映していない（新規行はnull）ため、
      // updateDocument/copyDocumentSaveと同様にsort_keyを振り直す。
      // （インポート時はsort_keyでソートされるため、ここで正しい順序を確定させる必要がある）
      // インポート時に参照される項目のみを出力する（key/uuid/status等の実行時状態は出力しない）
      const outputContents = [];
      let currentContent = this.contents[0];
      let sortKeyCount = 0;
      while (currentContent) {
        outputContents.push({
          body: currentContent.body,
          tag_type: currentContent.tag_type,
          sort_key: sortKeyCount, // sort_keyは連結リストの順序で振り直す
          // stryファイルはDB(コードユニット基準)と同じ形式で出力する（in-memoryは書記素基準のため変換する）
          style: currentContent.styleAsCodeUnit(),
        });
        sortKeyCount++;
        currentContent = currentContent.next;
      }
      // 保存するデータの構造
      const data = {
        version: CONSTS.STRY_FILE_VERSION,
        documentId: this.documentId,
        title: this.title,
        content: outputContents,
        updatedAt: new Date().toISOString(),
      };

      const blob = new Blob([JSON.stringify(data)], { type: 'text/plain' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `${this.title}.stry`; // 独自拡張子
      link.click();

      URL.revokeObjectURL(url);
    },
    /**
     * 検索結果のうち選択されているcontentをcurrentSearchにセットする
     * @param directionOfArrow 矢印ボタンの方向
     */
    setCurrentSearchContent(directionOfArrow) {
      let results = this.contents.filter((content) => content.body.includes(this.searchWord));
      let beforeCurrentSearch = this.currentSearch;
      // 既に選ばれているcurrentSearchがresultsの中で何番目か
      let index = results.findIndex((content) => content.uuid == beforeCurrentSearch.content.uuid);
      let hashContent = {};
      let beforeCurrentSearchIndexArray = [];
      // 1行に検索ワードが2つ以上ある場合の対応
      if (beforeCurrentSearch.content.itemsCount > 1) {
        beforeCurrentSearchIndexArray.push(beforeCurrentSearch.content.searchWordStartIndex);
        const swLen = graphemeCount(this.searchWord);
        let sliceContentBody = sliceGraphemes(
          beforeCurrentSearch.content.updatingbody,
          beforeCurrentSearch.content.searchWordStartIndex + swLen,
        );
        // 削られた文字の数
        let sliceWordCount = beforeCurrentSearch.content.searchWordStartIndex;
        for (let i = 1; i < beforeCurrentSearch.content.itemsCount; i++) {
          const cu = sliceContentBody.indexOf(this.searchWord);
          const searchWordIndex = cu < 0 ? -1 : codeUnitToGrapheme(sliceContentBody, cu);
          // 削るたびに更新
          sliceWordCount += searchWordIndex + swLen;
          beforeCurrentSearchIndexArray.push(sliceWordCount);
          sliceContentBody = sliceGraphemes(sliceContentBody, searchWordIndex + swLen);
        }
      }
      // beforeCurrentSearch.contentのindexがarrayの何番目か（その行の何個目の該当箇所だったのか）
      let indexArrayIndex = beforeCurrentSearchIndexArray.findIndex((index) => index == beforeCurrentSearch.index);
      let IndexByMultipleSelectInOneLine = null;
      if (directionOfArrow == 'up') {
        if (beforeCurrentSearch.content.itemsCount > 1) {
          if (![0, -1].includes(indexArrayIndex)) {
            // 次がbeforeCurrentSearchと同じ行だった場合
            hashContent = beforeCurrentSearch.content;
            IndexByMultipleSelectInOneLine = beforeCurrentSearchIndexArray[indexArrayIndex - 1];
          } else {
            // 別の行だった場合
            hashContent = results.find((content, i) => i == index - 1)
              ? results.find((content, i) => i == index - 1)
              : results[results.length - 1];
            if (hashContent?.itemsCount > 1) {
              let currentSearchIndexArray = [hashContent.searchWordStartIndex];
              const swLen = graphemeCount(this.searchWord);
              let sliceContentBody = sliceGraphemes(hashContent.updatingbody, hashContent.searchWordStartIndex + swLen);
              // 削られた文字の数
              let sliceWordCount = hashContent.searchWordStartIndex;
              for (let i = 1; i < hashContent.itemsCount; i++) {
                const cu = sliceContentBody.indexOf(this.searchWord);
                const searchWordIndex = cu < 0 ? -1 : codeUnitToGrapheme(sliceContentBody, cu);
                // 削るたびに更新
                sliceWordCount += searchWordIndex + swLen;
                currentSearchIndexArray.push(sliceWordCount);
                sliceContentBody = sliceGraphemes(sliceContentBody, searchWordIndex + swLen);
              }
              IndexByMultipleSelectInOneLine = currentSearchIndexArray[currentSearchIndexArray.length - 1];
            }
          }
        } else {
          hashContent = results.find((content, i) => i == index - 1)
            ? results.find((content, i) => i == index - 1)
            : results[results.length - 1];
          if (hashContent?.itemsCount > 1) {
            let currentSearchIndexArray = [hashContent.searchWordStartIndex];
            const swLen = graphemeCount(this.searchWord);
            let sliceContentBody = sliceGraphemes(hashContent.updatingbody, hashContent.searchWordStartIndex + swLen);
            // 削られた文字の数
            let sliceWordCount = hashContent.searchWordStartIndex;
            for (let i = 1; i < hashContent.itemsCount; i++) {
              const cu = sliceContentBody.indexOf(this.searchWord);
              const searchWordIndex = cu < 0 ? -1 : codeUnitToGrapheme(sliceContentBody, cu);
              // 削るたびに更新
              sliceWordCount += searchWordIndex + swLen;
              currentSearchIndexArray.push(sliceWordCount);
              sliceContentBody = sliceGraphemes(sliceContentBody, searchWordIndex + swLen);
            }
            IndexByMultipleSelectInOneLine = currentSearchIndexArray[currentSearchIndexArray.length - 1];
          }
        }
      } else {
        if (beforeCurrentSearch.content.itemsCount > 1 && indexArrayIndex != beforeCurrentSearchIndexArray.length - 1) {
          hashContent = beforeCurrentSearch.content;
          IndexByMultipleSelectInOneLine = beforeCurrentSearchIndexArray[indexArrayIndex + 1];
        } else {
          hashContent = results.find((content, i) => i == index + 1)
            ? results.find((content, i) => i == index + 1)
            : results[0];
        }
      }
      this.currentSearch = {
        content: hashContent,
        index: !IndexByMultipleSelectInOneLine ? hashContent.searchWordStartIndex : IndexByMultipleSelectInOneLine,
      };
      // 検索された部分にスクロール
      document
        .querySelectorAll(`[data-contentid="${this.currentSearch.content.uuid}"]`)[0]
        .scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    /**
     * 置換
     * @param isAllReplace 全置換かどうか
     */
    replaceWithSearchWord(isAllReplace = false) {
      if (isAllReplace) {
        this.searchResults.forEach((content) => {
          for (let i = 0; i < content.itemsCount; i++) {
            content.updateBody(content.updatingbody.replace(this.searchWord, this.replacementWord));
          }
          content.searchWordStartIndex = null;
          content.status = 'editing';
        });
      } else {
        let targetContent = this.currentSearch.content;
        let beforebody = sliceGraphemes(targetContent.body, 0, this.currentSearch.index);
        let afterbody = sliceGraphemes(targetContent.body, this.currentSearch.index);
        targetContent.updateBody(beforebody + afterbody.replace(this.searchWord, this.replacementWord));
      }
      let results = this.contents.filter((content) => content.body.includes(this.searchWord));
      if (results.length == 0) {
        this.contents.forEach((content) => {
          content.searchWordStartIndex = null;
          content.itemsCount = null;
        });
        this.currentSearch.content = null;
        this.currentSearch.index = null;
      } else {
        results.forEach((content) => {
          content.searchWordStartIndex = codeUnitToGrapheme(content.body, content.body.indexOf(this.searchWord));
          // 1行の中で検索文字列がヒットする数
          content.itemsCount = content.body.split(this.searchWord).length - 1;
        });
        this.currentSearch.content = results[0];
        this.currentSearch.index = results[0].searchWordStartIndex;
      }
    },
    /**
     * styleを適用
     * @param styleType styleの種類
     */
    applyStyle(styleType) {
      if (this.selectFrom.contentID == '' || this.selectTo.contentID == '') return;
      // スタイル変更前にundo記録を取る
      this.pushUndo();
      this.resetRedoRecords();
      const fromContent = this.contentMap.get(this.selectFrom.contentID);
      if (this.selectFrom.contentID == this.selectTo.contentID) {
        let sameRangeStyle = fromContent.style.filter(
          (style) =>
            style.start_index <= style.end_index &&
            style.style_type == styleType &&
            style.start_index <= fromContent.selectFrom &&
            fromContent.selectTo <= style.end_index,
        )[0];
        if (sameRangeStyle) {
          fromContent.style = fromContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType ||
                fromContent.selectFrom > style.end_index ||
                style.start_index > fromContent.selectTo),
          );
          if (sameRangeStyle.start_index < fromContent.selectFrom) {
            fromContent.style.push({
              style_type: styleType,
              start_index: sameRangeStyle.start_index,
              end_index: fromContent.selectFrom - 1,
            });
          }
          if (sameRangeStyle.end_index > fromContent.selectTo) {
            fromContent.style.push({
              style_type: styleType,
              start_index: fromContent.selectTo + 1,
              end_index: sameRangeStyle.end_index,
            });
          }
        } else {
          let inRangeFromStyle = fromContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= fromContent.selectFrom &&
              fromContent.selectFrom <= style.end_index + 1,
          )[0];
          let inRangeToStyle = fromContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= fromContent.selectTo + 1 &&
              fromContent.selectTo <= style.end_index,
          )[0];
          fromContent.style = fromContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType ||
                fromContent.selectFrom > style.end_index + 1 ||
                style.start_index > fromContent.selectTo + 1),
          );
          fromContent.style.push({
            style_type: styleType,
            start_index: inRangeFromStyle ? inRangeFromStyle.start_index : fromContent.selectFrom,
            end_index: inRangeToStyle ? inRangeToStyle.end_index : fromContent.selectTo,
          });
        }
      } else {
        let toContent = null;
        let currentContent = fromContent;
        let isNext = false;
        while (currentContent && !toContent) {
          if (currentContent.uuid == this.selectTo.contentID) {
            toContent = currentContent;
            isNext = true;
          }
          currentContent = currentContent.next;
        }
        currentContent = fromContent;
        while (currentContent && !toContent) {
          if (currentContent.uuid == this.selectTo.contentID) {
            toContent = currentContent;
            isNext = false;
          }
          currentContent = currentContent.previous;
        }
        if (!toContent) return;
        let isStyled = true;
        currentContent = isNext ? fromContent : toContent;
        const endContent = isNext ? toContent : fromContent;
        while (currentContent != endContent && isStyled) {
          if (
            currentContent.selectTo >= 0 &&
            !currentContent.style.some(
              (style) =>
                style.start_index <= style.end_index &&
                style.style_type == styleType &&
                style.start_index <= currentContent.selectFrom &&
                currentContent.selectTo <= style.end_index,
            )
          ) {
            isStyled = false;
          }
          currentContent = currentContent.next;
        }
        if (
          !currentContent.style.some(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= currentContent.selectFrom &&
              currentContent.selectTo <= style.end_index,
          )
        ) {
          isStyled = false;
        }
        currentContent = isNext ? fromContent : toContent;
        if (isStyled) {
          let inRangeFromStyle = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= currentContent.selectFrom,
          )[0];
          currentContent.style = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType || style.end_index < currentContent.selectFrom),
          );
          if (inRangeFromStyle && inRangeFromStyle.start_index < currentContent.selectFrom) {
            currentContent.style.push({
              style_type: styleType,
              start_index: inRangeFromStyle.start_index,
              end_index: currentContent.selectFrom - 1,
            });
          }
          currentContent = currentContent.next;
          while (currentContent != endContent) {
            currentContent.style = currentContent.style.filter(
              (style) => style.start_index <= style.end_index && style.style_type != styleType,
            );
            currentContent = currentContent.next;
          }
          let inRangeToStyle = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              currentContent.selectTo <= style.end_index,
          )[0];
          currentContent.style = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType || style.start_index > currentContent.selectTo),
          );
          if (inRangeToStyle && inRangeToStyle.end_index > currentContent.selectTo) {
            currentContent.style.push({
              style_type: styleType,
              start_index: currentContent.selectTo + 1,
              end_index: inRangeToStyle.end_index,
            });
          }
        } else {
          let inRangeFromStyle = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= currentContent.selectFrom &&
              currentContent.selectFrom <= style.end_index + 1,
          )[0];
          currentContent.style = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType || style.end_index + 1 < currentContent.selectFrom),
          );
          currentContent.style.push({
            style_type: styleType,
            start_index: inRangeFromStyle ? inRangeFromStyle.start_index : currentContent.selectFrom,
            end_index: currentContent.selectTo,
          });
          currentContent = currentContent.next;
          while (currentContent != endContent) {
            if (currentContent.selectTo >= 0) {
              currentContent.style = currentContent.style.filter(
                (style) => style.start_index <= style.end_index && style.style_type != styleType,
              );
              currentContent.style.push({
                style_type: styleType,
                start_index: currentContent.selectFrom,
                end_index: currentContent.selectTo,
              });
            }
            currentContent = currentContent.next;
          }
          let inRangeToStyle = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              style.style_type == styleType &&
              style.start_index <= currentContent.selectTo + 1 &&
              currentContent.selectTo <= style.end_index,
          )[0];
          currentContent.style = currentContent.style.filter(
            (style) =>
              style.start_index <= style.end_index &&
              (style.style_type != styleType || style.start_index > currentContent.selectTo + 1),
          );
          currentContent.style.push({
            style_type: styleType,
            start_index: currentContent.selectFrom,
            end_index: inRangeToStyle ? inRangeToStyle.end_index : currentContent.selectTo,
          });
        }
      }
      this.addConfirmEvent();
      return;
    },
    /**
     * リサイズハンドルのドラッグ開始（柱一覧メニュー用）
     * @param event マウスイベント
     */
    startResize(event) {
      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragStartWidth = this.hashiraListWidth;
      event.preventDefault();
    },
    /**
     * リサイズハンドルのドラッグ中（柱一覧メニュー用）
     * @param event マウスイベント
     */
    doResize(event) {
      if (!this.isDragging) return;
      const deltaX = event.clientX - this.dragStartX;
      const newWidth = this.dragStartWidth + deltaX;
      // 最小幅100px、最大幅350px
      if (newWidth >= 100 && newWidth <= 350) {
        this.hashiraListWidth = newWidth;
      }
    },
    /**
     * リサイズハンドルのドラッグ終了（柱一覧メニュー用）
     */
    stopResize() {
      this.isDragging = false;
    },
    /**
     * 指定の文字数のみを表示
     * @return {String}
     */
    truncate(letter, length) {
      if (letter) {
        return letter.length <= length ? letter : letter.substr(0, length) + '...';
      }

      return '';
    },
    composingStartHandler() {
      this.pushUndo();
      this.resetRedoRecords();
      this.isComposing = true;
      this.isMouseDown = false; // 日本語入力中はマウスダウン状態を解除しておく
      this.enterKeyPressed = false; // 前回セッションの押下記録を持ち越さない
    },
    /**
     * 検索ハイライト状態をリセットする
     */
    resetSearchHighlight() {
      this.contents.forEach((content) => {
        content.searchWordStartIndex = null;
        content.itemsCount = null;
      });
      this.currentSearch.content = null;
      this.currentSearch.index = null;
    },
    /**
     * IME変換確定時に、編集したコンテンツの検索情報だけを更新する（再検索）
     * 変換中はupdatingbodyにプレースホルダが入り検索位置がズレるため、確定後に該当コンテンツの
     * searchWordStartIndex/itemsCountを再計算し、現在ヒット（緑）の位置も補正する。
     * @param {Content} content 編集が確定したコンテンツ
     */
    reSearchEditedContent(content) {
      if (!this.isSearchable || this.searchWord === '' || !content) return;

      // 現在ヒット（緑）のコンテンツが削除（結合）されて存在しなくなった場合は先頭の検索結果へ移動
      if (this.currentSearch.content && !this.contents.includes(this.currentSearch.content)) {
        const results = this.searchResults;
        if (results.length > 0) {
          this.currentSearch.content = results[0];
          this.currentSearch.index = results[0].searchWordStartIndex;
        } else {
          this.currentSearch.content = null;
          this.currentSearch.index = null;
        }
      }

      if (content.body.includes(this.searchWord)) {
        content.searchWordStartIndex = content.body.indexOf(this.searchWord);
        content.itemsCount = content.body.split(this.searchWord).length - 1;

        // 編集したコンテンツが現在ヒット（緑）だった場合、位置がズレている可能性があるため補正
        if (this.currentSearch.content?.uuid === content.uuid) {
          const matchIndexes = [];
          let from = content.body.indexOf(this.searchWord);
          while (from !== -1) {
            matchIndexes.push(from);
            from = content.body.indexOf(this.searchWord, from + this.searchWord.length);
          }
          // 既存のindexが有効なヒット位置でなければ、最も近いヒット位置へ寄せる
          if (!matchIndexes.includes(this.currentSearch.index)) {
            this.currentSearch.index = matchIndexes.reduce(
              (nearest, idx) =>
                Math.abs(idx - this.currentSearch.index) < Math.abs(nearest - this.currentSearch.index) ? idx : nearest,
              matchIndexes[0],
            );
          }
        }
      } else {
        // 編集で該当が無くなった場合
        content.searchWordStartIndex = null;
        content.itemsCount = null;
        // 現在ヒット（緑）が消えた場合は先頭の検索結果へ移動
        if (this.currentSearch.content?.uuid === content.uuid) {
          const results = this.searchResults;
          if (results.length > 0) {
            this.currentSearch.content = results[0];
            this.currentSearch.index = results[0].searchWordStartIndex;
          } else {
            this.currentSearch.content = null;
            this.currentSearch.index = null;
          }
        }
      }

      // 現在ヒット（緑）が未設定の状態から、編集で検索対象が発生した場合は先頭の検索結果を現在ヒットにする
      // （カーソル位置を妨げないよう、この昇格ではスクロールしない）
      if (!this.currentSearch.content) {
        const results = this.searchResults;
        if (results.length > 0) {
          this.currentSearch.content = results[0];
          this.currentSearch.index = results[0].searchWordStartIndex;
        }
      }
    },
  },
  watch: {
    // 検索が無効化されたときに検索状態をクリーンアップ
    isSearchable(newVal) {
      if (!newVal) this.resetSearchHighlight();
    },
    searchWord(newVal) {
      if (newVal === '') {
        this.resetSearchHighlight();
      } else {
        // searchWord変更時にcurrentSearchを初期化（最初の検索結果にセット）
        const results = this.searchResults;
        if (results.length > 0) {
          const firstResult = results[0];
          this.currentSearch.content = firstResult;
          this.currentSearch.index = firstResult.searchWordStartIndex;
          this.$nextTick(() => {
            document
              .querySelectorAll(`[data-contentid="${firstResult.uuid}"]`)[0]
              ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          });
        } else {
          this.currentSearch.content = null;
          this.currentSearch.index = null;
        }
      }
    },
  },
};
</script>

<style scoped>
:deep(.el-menu-item:hover) {
  background-color: #dee4e6 !important;
  /* color: white !important; */
}

:deep(.el-switch.is-checked .el-switch__core .el-switch__inner .is-text) {
  color: #647484;
}

.hashira-resize-handle {
  position: absolute;
  top: 2em;
  right: 0;
  width: 4px;
  height: 46em;
  cursor: col-resize;
  user-select: none;
  transition: background-color 0.2s ease;
}

kbd {
  display: inline-block;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.4;
  color: #24292e;
  vertical-align: middle;
  background-color: #fafbfc;
  border: 1px solid #d1d5da;
  border-radius: 3px;
  box-shadow: inset 0 -1px 0 #d1d5da;
}

.el-icon.pointer {
  transition: color 0.2s ease;
}

.el-icon.pointer:hover {
  color: #91cdbe !important;
}

.help-popover-content {
  /* 配色・余白はここで一元管理（将来のテーマ/ダークモード対応もこの変数を上書きするだけ） */
  --help-accent: #91cdbe;
  --help-heading-size: 15px;
  --help-tips-bg: #eef7f4;
  --help-tips-text: #4a5560;
  --help-divider: #ebe8e6;
  max-height: 400px;
  overflow-y: auto;
}

/* セクション見出し（ショートカット / Tips 共通） */
.help-section-heading {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 10px;
}

.help-section-icon {
  width: 18px;
  height: 18px;
  color: var(--help-accent);
  flex-shrink: 0;
}

.help-section-title {
  margin: 0;
  color: var(--help-accent);
  font-size: var(--help-heading-size);
  font-weight: 600;
}

/* Tips セクション */
.tips-section {
  margin-top: 18px;
  padding-top: 14px;
}

.tips-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tips-item {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--help-tips-text);
  background: var(--help-tips-bg);
  border-left: 3px solid var(--help-accent);
  border-radius: 6px;
}

.tips-bullet {
  color: var(--help-accent);
  font-weight: 700;
}

.help-popover-content::-webkit-scrollbar {
  width: 6px;
}

.help-popover-content::-webkit-scrollbar-track {
  background: transparent;
}

.help-popover-content::-webkit-scrollbar-thumb {
  background-color: #c0c4cc;
  border-radius: 3px;
}

.help-popover-content::-webkit-scrollbar-thumb:hover {
  background-color: #909399;
}

.pdf-warning-body {
  color: #4b5563;
  margin-bottom: 12px;
}

.pdf-warning-title {
  margin-bottom: 12px;
  line-height: 1.7;
}

.pdf-warning-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.pdf-warning-table th,
.pdf-warning-table td {
  border-bottom: 1px solid #eceff1;
  padding: 10px 8px;
  text-align: left;
  vertical-align: top;
}

.pdf-warning-table th {
  color: #647484;
  font-weight: 600;
}

.pdf-warning-char {
  display: inline-flex;
  min-width: 42px;
  justify-content: center;
  align-items: center;
  padding: 0 6px;
  border-radius: 6px;
  background: transparent;
  border: none;
  font-size: 16px;
  font-family: 'Hiragino Kaku Gothic ProN', 'Yu Gothic', 'Yu Mincho', 'Noto Sans JP', 'Noto Serif JP', sans-serif;
}

.pdf-warning-code {
  white-space: nowrap;
  color: #6b7280;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
}

.pdf-warning-dialog-footer {
  width: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}
.pdf-warning-note {
  margin-top: 12px;
  margin-bottom: 0;
  font-size: 12px;
  color: #8a94a4;
}
</style>
